import { render } from "./HeroiconsOutlineSearchCircle.vue?vue&type=template&id=70674936"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSearchCircle.vue"]])

export default __exports__